// extracted by mini-css-extract-plugin
export default {"card":"Card_card__kJC0F","data":"Card_data__65Xu1","tematicas":"Card_tematicas__Fw+5-","infoInferior":"Card_infoInferior__NLU9A","types":"Card_types__u2Tgb"};